import React, { useEffect, useState } from 'react';
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  const hh = Math.floor(seconds / 3600);
  const mm = Math.floor(seconds % 3600 / 60);
  const ss = seconds % 60;
  return {
    hh,
    mm,
    ss
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-31" data-mp="3h18xkxr6kc9m">
      <div className="flex h-16 w-16 items-center justify-center rounded-xl border border-white/10 bg-ink font-display text-3xl font-black tabular-nums text-white sm:h-20 sm:w-20 sm:text-4xl" data-id="element-32" data-mp="3gyw5hrrpkliu">
        {String(value).padStart(2, '0')}
      </div>
      <span className="mt-2 text-[10px] font-bold uppercase tracking-widest text-white/50" data-id="element-33" data-mp="10btlloiz30rk">
        {label}
      </span>
    </div>;
}
export function Countdown() {
  const {
    hh,
    mm,
    ss
  } = useCountdown(23 * 3600 + 59 * 60 + 47);
  return <section aria-label="Cuenta regresiva" className="bg-ink" data-id="element-34" data-mp="xzc0dwupmfn5">
      <div className="mx-auto max-w-3xl px-5 pt-[6px] pb-[0px] text-center" data-id="element-35" data-mp="t2v8qsoaxj5b">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-azure pt-[4px]" data-id="element-36" data-mp="17qq4yj1iq5n5">
          ⏰ Precio de lanzamiento — cierra en:
        </p>
        <div className="mt-6 flex items-center justify-center gap-3 sm:gap-5" data-id="element-37" data-mp="12sev48b83v4x">
          <Unit value={hh} label="Horas" data-id="element-38" data-mp="f3dl4gmqsbxj" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-39" data-mp="f45dzjoyfvk4">:</span>
          <Unit value={mm} label="Min" data-id="element-40" data-mp="a527dutbtha1" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-41" data-mp="o2qqax3u2ecg">:</span>
          <Unit value={ss} label="Seg" data-id="element-42" data-mp="k1ezio983n2o" />
        </div>
        <p className="mt-6 text-sm font-semibold text-white/60" data-id="element-43" data-mp="k0m42jfpsjzu">
          ⚠️ Después sube $35.000 ARS. No vuelve a este precio.
        </p>

        <div className="mx-auto mt-8 max-w-md" data-id="element-44" data-mp="1vgkh0ye0jq6c">
          <p className="mb-2 text-left text-xs font-semibold text-white/60" data-id="element-45" data-mp="1vfsk9k8ojmeh">
            🔴 Cupos al precio de lanzamiento
          </p>
          <div className="h-3 w-full overflow-hidden rounded-full bg-white/10" data-id="element-46" data-mp="s7r99g26slac">
            <div className="h-full w-[68%] rounded-full bg-iris" data-id="element-47" data-mp="x2wq40gqf9rk" />
          </div>
          <p className="mt-2 text-right text-xs font-bold text-iris-soft" data-id="element-48" data-mp="1255mz7wq6vyy">
            68% tomados — Quedan pocos
          </p>
        </div>
      </div>
    </section>;
}